const LangEgiftCard = {
	"egift.givingMadeEasy": ["Giving made easy", "Tặng quà thật dễ!"],
	"egift.signInOrCreateAnAccount": [
		"Sign in or Create an Account",
		"Đăng nhập hoặc tạo tài khoản mới",
	],
	"egift.withYourStarbucks": [
		"With your Starbucks, it is easy to manage your Starbucks Cards, track your rewards, and get our latest news.",
		"Với tài khoản Starbucks Rewards, bạn sẽ dễ dàng quản lý thẻ, theo dõi các phần quà thưởng và nhận các thông tin mới nhất từ chúng tôi.",
	],
	"egift.sendAStarbucksEgift": ["Send a Starbucks E-Gift", "Gửi thẻ quà tặng điện tử"],
	"egift.sendAStarbucksCard": [
		"Send a Starbucks Card to your loved ones with the new eGift feature.",
		"Gửi quà tặng đến người bạn yêu thương với thẻ quà tặng điện tử.",
	],
}

export default LangEgiftCard



// WEBPACK FOOTER //
// ./src/resources/pages/LangEgift.js